import { createSlice } from '@reduxjs/toolkit';

const PAGE_SIZE = 12;

export const initialFilterValues = {
  passType: '',
  event: '',
  status: '',
};

export const initialSortValues = {
  sortBy: '',
  sortOrder: '',
};

export const initialPassTemplates = {
  items: [],
  included: [],
  total: 0,
  pageIndex: 0,
  pageSize: PAGE_SIZE,
  hasMore: false,
  status: 'pending',
  loading: false,
  error: null,
};

const initialState = {
  passTemplates: initialPassTemplates,
  filterValues: initialFilterValues,
  sortValues: initialSortValues,
  clearPageIndex: 0,
};

const slice = createSlice({
  name: 'passTemplatesList',
  initialState,
  reducers: {
    updatePassTemplates(state, action) {
      state.passTemplates = action.payload;
    },

    updateFilterValues(state, action) {
      state.filterValues = action.payload;
      state.clearPageIndex += 1;
    },

    updateSortValues(state, action) {
      state.sortValues = action.payload;
      state.clearPageIndex += 1;
    },

    incrementPageIndex(state) {
      state.passTemplates.pageIndex += 1;
    },

    resetPageIndex(state) {
      state.passTemplates.pageIndex = 0;
    },

    mergePassTemplates(state, action) {
      Object.assign(state.passTemplates, action.payload);
    },

    resetAll(state) {
      state.passTemplates = initialPassTemplates;
      state.filterValues = initialFilterValues;
      state.sortValues = initialSortValues;
      state.clearPageIndex = 0;
    },
  },
});

export const {
  updatePassTemplates,
  updateFilterValues,
  updateSortValues,
  incrementPageIndex,
  resetPageIndex,
  mergePassTemplates,
  resetAll,
} = slice.actions;

export default slice.reducer;

export const selectPassTemplates = (state) =>
  state.passTemplatesList.passTemplates;
export const selectFilterValues = (state) =>
  state.passTemplatesList.filterValues;
export const selectSortValues = (state) => state.passTemplatesList.sortValues;
export const selectClearPageIndex = (state) =>
  state.passTemplatesList.clearPageIndex;
